import { useQuery } from '@tanstack/react-query';
import { useRouteContext } from '@tanstack/react-router';
import { meContext } from '@ooh/contracts';
import type { MeContextResponse } from '@ooh/contracts';

export const ME_CONTEXT_QUERY_KEY = ['me', 'context'] as const;

export function useContextQuery() {
  const { auth } = useRouteContext({ from: '__root__' });
  return useQuery<MeContextResponse>({
    queryKey: ME_CONTEXT_QUERY_KEY,
    queryFn: () => auth.callWithAuth(meContext.get, {}) as Promise<MeContextResponse>,
    staleTime: 300_000,
  });
}
